// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__NUvOZ","col":"CardReaderDesc_col__3wfJQ","label":"CardReaderDesc_label__1HZPn"};